// DetailScreen.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db, logFirebaseEvent } from '../firebase';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import Topbar from './Topbar';
import Footer from './Footer';
import globalState from '../globalstate';
import StatisticSection from './StatisticSection';
import { observer } from "mobx-react-lite";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const languageMapping = {
  en: 'English',
  ms: 'Bahasa Malaysia',
  zh: 'Chinese',
  All: 'All', // Add 'All' if you want it to remain the same
};

const DetailScreen = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [serviceProvider, setServiceProvider] = useState(null);
  const [services, setServices] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('All');
  const [selectedSorting, setSelectedSorting] = useState('A-Z');
  const [selectedType, setSelectedType] = useState('All');
  const [orderInCartMap, setOrderInCartMap] = useState({});
  const [isVerticalLayout, setIsVerticalLayout] = useState(window.innerWidth < window.innerHeight);

  useEffect(() => {
    logFirebaseEvent(`viewDetails${id}`, { publisherId: id });
    fetchServiceProvider();
    const handleResize = () => {
      setIsVerticalLayout(window.innerWidth < window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchServiceProvider = async () => {
    console.log('Fetch service provider');
    try {
      const providerRef = doc(db, 'serviceProvider', id);
      const providerSnapshot = await getDoc(providerRef);
      const providerData = { id: providerSnapshot.id, ...providerSnapshot.data() };
      setServiceProvider(providerData);
      fetchServices(providerData);
    } catch (error) {
      console.error('Error fetching service provider:', error);
    }
  };

  const handleOrderChange = (serviceId, change) => {
    setOrderInCartMap((prev) => {
      const updated = { ...prev };
      const current = updated[serviceId] || 1;
      const newCount = Math.max(0, current + change);
      updated[serviceId] = newCount; // Update the item count
      return updated;
    });
  };
  

  const fetchServices = async (provider) => {
    console.log('Fetch service');
    try {
      const servicesQuery = query(
        collection(db, 'service'),
        where('isActive', '==', true),
        where('serviceProviderId', '==', provider.id),
        where('isShowItem', '==', true)
      );
      const servicesSnapshot = await getDocs(servicesQuery);
      const servicesData = servicesSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setServices(servicesData);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  const filteredServices = services
    .filter((service) => {
      if (selectedType !== 'All' && service.category.toLowerCase() !== selectedType.toLowerCase()) {
        return false;
      }
      if (selectedLanguage !== "All" && service.language !== selectedLanguage) {
        return false;
      }
      return true;
    })
    .sort((a, b) => {
      if (selectedSorting === 'A-Z') return a.serviceTitle.localeCompare(b.serviceTitle);
      if (selectedSorting === 'Z-A') return b.serviceTitle.localeCompare(a.serviceTitle);
      if (selectedSorting === 'Price ↑') return a.priceStartsFrom - b.priceStartsFrom;
      if (selectedSorting === 'Price ↓') return b.priceStartsFrom - a.priceStartsFrom;
      return 0;
    });

  return (
    <div style={{ backgroundColor: '#f2f2f2', minHeight: '100vh', position: 'relative' }}>
      
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
        <Topbar />
      </div>
      <div style={{ padding: '16px', margin: isVerticalLayout ? '56px 0px':'56px 64px' }}>
        {serviceProvider && (
          <div>
            {/* <div style={{ fontSize: '14px', color: '#333' }}>
              <button
                onClick={() => navigate('/adwav')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'black', fontWeight: 'bold' }}
              >
                Home
              </button>
              <span style={{ margin: '0 8px', color: 'black' }}> &gt; </span>
              <span style={{ fontWeight: 'bold' }}>{serviceProvider.name}</span>
            </div> */}
            <div style={{ margin: '16px 0' }}>
              <div
                style={{
                  padding: '16px',
                  border: '1px solid rgba(0, 0, 0, 0.35)',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '32px',
                }}
              >
                <div
                  style={{
                    width: '90px',
                    height: '90px',
                    borderRadius: '50%',
                    backgroundImage: `url(${serviceProvider.coverImageUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                ></div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex' }}>
                    <div style={{ marginRight: '64px' }}>
                      <div style={{ fontSize: '12px', color: 'grey' }}>Publisher</div>
                      <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{serviceProvider.name}</div>
                    </div>
                    {!isVerticalLayout && <div>
                      <div style={{ fontSize: '12px', color: 'grey' }}>Category</div>
                      <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{serviceProvider.category}</div>
                    </div>}
                  </div>
                    {isVerticalLayout && <div style={{ marginTop: '8px' }}>
                      <div style={{ fontSize: '12px', color: 'grey' }}>Category</div>
                      <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{serviceProvider.category}</div>
                    </div>}
                  <div style={{ marginTop: '8px' }}>
                    <div style={{ fontSize: '12px', color: 'grey' }}>Language</div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                      {serviceProvider.language
                        .map(lang => languageMapping[lang])
                        .sort((a, b) => a.localeCompare(b))
                        .join(', ')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div style={{ backgroundColor: '#f2f2f2', paddingBottom: '16px' }}>

        {serviceProvider && <StatisticSection serviceProvider={serviceProvider} />}

      <div
          style={{
            padding: isVerticalLayout ? '20px 0px' : '20px 0px',
            display: isVerticalLayout ? '':'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
      >
        <div
  style={{
    display: isVerticalLayout ? '' : 'flex',
    gap: isVerticalLayout ? '0px' : '8px',
    flexWrap: isVerticalLayout ? '' : 'wrap',
    height: isVerticalLayout ? '50px' : 'auto', // Add height for vertical layout
    overflowY: isVerticalLayout ? 'auto' : 'visible', // Ensure scroll if content overflows
  }}
>
{['All', 'Articles', 'Videos', 'Others'].map((type) => (
  <button
    key={type}
    onClick={() => setSelectedType(type)}
    style={{
      padding: '8px 16px',
      backgroundColor: selectedType === type ? '#EC3535' : 'white',
      color: selectedType === type ? 'white' : 'black',
      border: `1px solid ${selectedType === type ? '#EC3535' : '#D8D8D8'}`,
      borderRadius: '16px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: selectedType === type ? 'bold' : 'normal',
      marginRight: isVerticalLayout ? '8px':'0px', // Added margin-right
    }}
  >
    {type}
  </button>
))}

</div>

        <div style={{ display: 'flex', gap: '8px' }}>
          <div
            style={{
              padding: isVerticalLayout ? '0px 0px' : '0 8px',
              backgroundColor: 'white',
              borderRadius: '8px',
              border: '1px solid rgba(0, 0, 0, 0.2)',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <select
              value={selectedLanguage}
              onChange={(e) => setSelectedLanguage(e.target.value)}
              style={{
                border: 'none',
                outline: 'none',
                background: 'transparent',
                fontSize: '14px',
                color: 'black',
              }}
            >
            {['All', 'ms', 'zh', 'en'].map((lang) => (
              <option key={lang} value={lang}>
                Language: {languageMapping[lang]}
              </option>
            ))}
            </select>
          </div>

          <div
            style={{
              padding: '0 8px',
              backgroundColor: 'white',
              borderRadius: '8px',
              border: '1px solid rgba(0, 0, 0, 0.2)',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <select
              value={selectedSorting}
              onChange={(e) => setSelectedSorting(e.target.value)}
              style={{
                border: 'none',
                outline: 'none',
                background: 'transparent',
                fontSize: '14px',
                color: 'black',
              }}
            >
              {['A-Z', 'Z-A', 'Price ↑', 'Price ↓'].map((sort) => (
                <option key={sort} value={sort}>
                  {sort}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      
    </div>
      </div>
      <div
                style={{
                  marginTop: '-70px',
                }}>
        {serviceProvider && (
          <div>
            <div >
              <div
                style={{
                  paddingLeft: '16px',
                  paddingRight: '16px',
                  borderRadius: '8px',
                }}
              >
                {filteredServices.map((service)=> {
                  if (!isVerticalLayout) {
                    return (
                      <div
                        key={service.id}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '16px',
                          margin: isVerticalLayout ? '16px 12px':'16px 64px',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          backgroundColor: 'white',
                        }}
                      >
                        {/* Left Section: Title and Details */}
                        <div style={{ flexGrow: 1 }}>
                          <h3 style={{ fontSize: '16px', fontWeight: 'bold' }}>
                            {service.serviceTitle}
                          </h3>
                          <div style={{ margin: '8px 0', padding: '0', color: '#666' }}>
                            {service.serviceDetails.map((detail, index) => (
                              <p key={index} style={{ fontSize: '14px', color: 'black', margin: '4px 0' }}>
                                {detail}
                              </p>
                            ))}
                          </div>
                        </div>

                  
                        {/* Right Section: Pricing, Quantity Controls, and Button */}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-end', // Aligns items to the end horizontally
                            gap: '16px',
                            flex: 2,
                          }}
                          
                        >
                          <div style={{ fontSize: '16px', minWidth: '100px', color: '#444', fontWeight: '500', alignItems: 'center', }}>
                            RM {service.priceStartsFrom.toLocaleString()}
                          </div>
                  
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button
                              style={{
                                padding: '4px 8px',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                background: '#fff',
                              }}
                              onClick={() => handleOrderChange(service.id, -1)}
                            >
                              −
                            </button>
                            <span style={{ fontSize: '16px' }}>{orderInCartMap[service.id] || 1}</span>
                            <button
                              style={{
                                padding: '4px 8px',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                background: '#fff',
                              }}
                              onClick={() => handleOrderChange(service.id, 1)}
                            >
                              +
                            </button>
                          </div>
                  
                          <button
                            style={{
                              width: '150px',
                              padding: '8px 0',
                              borderRadius: '8px',
                              backgroundColor: '#EC3535',
                              color: '#fff',
                              border: `1px solid ${'#EC3535'}`,
                              border: `1px solid red`,
                              fontWeight: 'bold',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              logFirebaseEvent(`bookItem${service.id}`, { adId: service.id });
                              globalState.updateOrder(service.id, orderInCartMap[service.id] || 1);
                              toast.success('Item has been added to cart', { autoClose: 2000 });
                            }}
                          >
                            Book Now
                          </button>
                        </div>
                      </div>
                    );
                  }
                    

                  return (
                    <div
                      key={service.id}
                      style={{
                        padding: '16px',
                        margin: '4px 0',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                      }}
                    >
                      <div>
                        <h3 style={{ margin: '8px 0', fontSize: '16px', fontWeight: 'bold' }}>{service.serviceTitle}</h3>
                        <ul style={{ margin: '8px 0', padding: '0 0px', color: '#444' }}>
                          {service.serviceDetails.map((detail, index) => (
                            <li key={index} style={{ fontSize: '14px', color: '#444' }}>{detail}</li>
                          ))}
                        </ul>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontSize: '16px', color: '#444', fontWeight: '500' }}>
                          RM {service.priceStartsFrom.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button
                              style={{ padding: '4px 8px', border: '1px solid #ccc', borderRadius: '8px', background: '#fff' }}
                              onClick={() => handleOrderChange(service.id, -1)}
                            >
                              −
                            </button>
                            <span style={{ fontSize: '16px' }}>{orderInCartMap[service.id] || 1}</span>
                            <button
                              style={{ padding: '4px 8px', border: '1px solid #ccc', borderRadius: '8px', background: '#fff' }}
                              onClick={() => handleOrderChange(service.id, 1)}
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <button
                          style={{
                            width: '100%',
                            marginTop: '16px',
                            padding: '8px 0',
                            borderRadius: '8px',
                            backgroundColor: '#EC3535',
                            color: '#fff',
                            border: `1px solid ${'#EC3535'}`,
                            fontWeight: 'bold',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            logFirebaseEvent(`bookItem${service.id}`, { adId: service.id });
                            globalState.updateOrder(service.id, orderInCartMap[service.id] || 1);
                            alert('Item has been added to your cart.');
                          }}
                        >
                          Book Now
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
      <div style={{ height: '64px' }}></div>
      <Footer />
      <ToastContainer position="top-center" />
    </div>
    
  );
};

export default DetailScreen;
